module.exports = __webpack_public_path__ + "img/bt_map_close_map_default.97dca159.svg";